import { useContext, useState } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import StatisticsComponent from "../components/ExpenseDateComp/StatisticsComponent";
import AppContext from "../context/app-context";
import { getWeeklyStats } from "../utils/dateHelpers";

export default function MetricsGraphPage() {
  const { userProfile, trackingItems = [] } = useContext(AppContext);
  return (
    <Container className="py-4">
      <div className="mb-4">
        <StatisticsComponent expensesItems={trackingItems} />
      </div>
    </Container>
  );
}
